import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { PrevTaawValues } from '@/types';
import { createSlice } from '@reduxjs/toolkit';

interface LopsState {
  lopData: string | null;
  taawValues: PrevTaawValues | null;
  taaw: string | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: LopsState = {
  lopData: null,
  taawValues: null,
  taaw: null,
  isRegenerated: undefined,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'lops',
  initialState,
  reducers: {
    setLopData(state, action) {
      state.lopData = action.payload.answer;
      state.taawValues = action.payload.taawValues;
      state.taaw = action.payload.taaw;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setLopData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setLopData, setTitle };

export const selectLopData = (state: State) => state[name];
export const selectLopIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectLopTitle = (state: State) => state[name].title;
